import moment from 'moment';
import { REQUEST_WIZARD_DATES, RECEIVE_WIZARD_DATES } from '../actions';

const today = new Date();
const dateMax = new Date(today);
dateMax.setFullYear(dateMax.getFullYear() + 2);

export function dates(state = {
  dates: null, minDate: today, maxDate: dateMax, wizardIsFetchingDates: false,
}, action) {
  switch (action.type) {
    case REQUEST_WIZARD_DATES:
      return {
        ...state,
        wizardIsFetchingDates: true,
      };

    case RECEIVE_WIZARD_DATES:
      let datesAreEmpty = true;
      let dates = null;
      let minDate = today;
      let maxDate = dateMax;

      if (action.dates && action.dates.length > 0 ) {
        dates = {};
        action.dates.forEach((dateData) => {
          const santizedTimestamp = parseInt(dateData.Date.replace(/\D/g, ''));
          dateData.Date = `${moment(santizedTimestamp).format('YYYYMMDD')}`;
          dates[dateData.Date] = dateData;
        });
        datesAreEmpty = false;
        minDate = moment(action.dates[0].Date, 'YYYYMMDD').toDate();
        maxDate = moment(action.dates[action.dates.length - 1].Date, 'YYYYMMDD').toDate();
      }

      return {
        ...state,
        dates,
        minDate,
        maxDate,
        selectedArrival: datesAreEmpty || (typeof dates[state.selectedArrival] === 'undefined') ? null : state.selectedArrival,
        wizardIsFetchingDates: false,
      };
  }

  return state;
}
